import React from 'react';
import styled from 'styled-components';
import { FontWeightNormal, FontWeightSemiBold, Spacing4 } from 'autogen/design-tokens/tokens';
import type { ProductNameLine } from 'autogen/swagger/all';
import InlineButton from 'components/generic/InlineButton/InlineButton';
import { Typography } from 'components/generic/typography';
import { em } from 'modules/helpers/style';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: auto;
    grid-auto-columns: auto;
`;

const Brand = styled(Typography.Title)`
    font-weight: ${FontWeightSemiBold};
    letter-spacing: ${em(1)};
    font-family: Arial, Helvetica, sans-serif;
`;

const Serie = styled(Typography.Title)`
    font-weight: ${FontWeightSemiBold};
    font-family: Arial, Helvetica, sans-serif;
`;

const Title = styled(Typography.Title)`
    font-weight: ${FontWeightNormal};
    font-family: Arial, Helvetica, sans-serif;
`;

const StyledInlineButton = styled(InlineButton)`
    justify-content: flex-start;
`;

export default function ChanelPageTitleNameRenderer({ lines }: { lines: ProductNameLine[] }): JSX.Element {
    const brand = lines.find((line) => line.type === 'Brand');
    const name = lines.find((line) => line.type === 'Name');
    const variant = lines.find((line) => line.type === 'Variant');
    const serie = lines.find((line) => line.type === 'Serie');

    return (
        <Wrapper>
            {brand && (
                <Brand size="L">
                    {brand.url ? (
                        <StyledInlineButton as="a" href={brand.url}>
                            {brand.value}
                        </StyledInlineButton>
                    ) : (
                        brand.value
                    )}
                </Brand>
            )}

            {serie && <Serie size="L">{serie.value}</Serie>}

            {name && (
                <Title size="L">
                    {name.value} {variant?.value}
                </Title>
            )}
        </Wrapper>
    );
}
